import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from '@pages/public/Home/HomePage';
import CustomerRegistrationPageModern from '@pages/public/CustomerRegistration/CustomerRegistrationPageModern';
import SupplierRegistrationPageModern from '@pages/public/SupplierRegistration/SupplierRegistrationPageModern';
import LoginPageModern from '@pages/admin/Login/LoginPageModern';
import DashboardPageModern from '@pages/admin/Dashboard/DashboardPageModern';
import RegistrationDetailPageModern from '@pages/admin/RegistrationDetail/RegistrationDetailPageModern';
import { UserManagementPage } from '@pages/admin/UserManagement/UserManagementPage';
import { SettingsPage } from '@pages/admin/Settings/SettingsPage';
import RegistrationLookupPage from '@pages/public/RegistrationLookup/RegistrationLookupPage';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<HomePage />} />

      {/* Customer Registration */}
      <Route path="/customer/register" element={<CustomerRegistrationPageModern />} />

      {/* Supplier Registration */}
      <Route path="/supplier/register" element={<SupplierRegistrationPageModern />} />

      {/* Registration Status Lookup */}
      <Route path="/check-status" element={<RegistrationLookupPage />} />

      {/* Admin Routes */}
      <Route path="/admin/login" element={<LoginPageModern />} />
      <Route path="/admin/dashboard" element={<DashboardPageModern />} />
      <Route path="/admin/registrations/:id" element={<RegistrationDetailPageModern />} />
      <Route path="/admin/users" element={<UserManagementPage />} />
      <Route path="/admin/settings" element={<SettingsPage />} />

      {/* 404 Not Found */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
